import { assert } from '@takeshape/util';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { clearForm, registerForm, submitForm } from '../../actions.js';
import { getFormSchema } from '../../selectors.js';
import type { Data, ResolveRef } from '../../types.js';
import { createResolveRef, splitRef } from '../../util/refs.js';
import type { SchemaFormHookProps, SchemaFormOwnProps } from './schema-form.js';

const resolveRefStub: ResolveRef = () => {
  assert(false, 'resolveRef should not be called before schema loads');
};

export function useSchemaForm<T extends Data = Data>(props: SchemaFormOwnProps<T>): SchemaFormHookProps<T> {
  const schemaRef = props.partial ? props.schemaRef : undefined;
  const rootSchema = useSelector((state) => getFormSchema(state, { formName: props.formName }));
  const componentSchema = useSelector((state) => getFormSchema(state, { formName: props.formName, schemaRef }));
  const schemaPath = schemaRef ? splitRef(schemaRef) : [];
  const resolveRef = useMemo(() => (rootSchema ? createResolveRef(rootSchema) : resolveRefStub), [rootSchema]);
  const dispatch = useDispatch();
  const actions = useMemo(
    () => bindActionCreators({ registerForm: registerForm<T>, clearForm, submitForm: submitForm<T> }, dispatch),
    [dispatch]
  );
  return {
    ...actions,
    schemaPath,
    resolveRef,
    componentSchema
  };
}
